Namespace 'Customer.Dashboard.TicketDetailsStats'

class Customer.Dashboard.TicketDetailsStats.IntegrationsView extends Backbone.View

  template: JST['backbone/templates/customer/ticket/detail/box/ticket_details_stats/integrations']

  initialize: ({ticket}) ->
    @integrations = ticket.get('integrations')

  render: =>
    @$el.html(@template())

    @salesforceIntegrationStatsView = new Customer.Dashboard.TicketDetailsStats.Integration.SalesforceView
      model: @integrations.get('salesforce')
      el: @$el.find('.salesforce-integration-stats')

    @patagoniaIntegrationStatsView = new Customer.Dashboard.TicketDetailsStats.Integration.PatagoniaView
      model: @integrations.get('patagonia')
      el: @$el.find('.patagonia-integration-stats')

    @salesforceIntegrationStatsView.render()
    @patagoniaIntegrationStatsView.render()
